import { render, staticRenderFns } from "./BoxToggler.vue?vue&type=template&id=96a0ab82&scoped=true&"
import script from "./BoxToggler.vue?vue&type=script&lang=js&"
export * from "./BoxToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a0ab82",
  null
  
)

export default component.exports